import { Injectable } from "@angular/core";
import { IGoogleAnalyticsConfig } from '@signature-it/ngx-generic/interfaces';
import { AbstractTracker } from '@signature-it/ngx-generic/classes';

declare let gtag: any;

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService extends AbstractTracker {
    readonly ATTR_TRACKER_NAME: string = "googleAnalytics";

    protected _config: IGoogleAnalyticsConfig;

    /**
     * @whatItDoes Add Google Analytics script to <body>
     * @param IGoogleAnalyticsConfig config
     */
    create(config: IGoogleAnalyticsConfig) {
        this._config = config;
        this._appendScripts(document.body);
        return this;
    }

    createGTM(config: IGoogleAnalyticsConfig) {
        this._config = config;
        this._appendGTMScripts(document.head);
        return this;
    }

    sendTerm(category: string, label: string): void {
        if(typeof gtag !== "undefined") {
            gtag('event', 'click' ,{
                'event_category' : category,
                'event_label' : encodeURI(label)
            });
        } else {
            console.log("gtag function isn't defined. Google Analytics doesn't triggered " + name +" events");
        }
    }

    sendSearchTerm(term: string): void {
        if(typeof gtag !== "undefined") {
            gtag('event', 'search', {'search_term' : encodeURI(term)});
        } else {
            console.log("gtag function isn't defined. Google Analytics doesn't triggered search events");
        }
    }

    protected _sendPageView(path: string): void {
        if(typeof gtag !== "undefined") {
            this._config.tracking_id.forEach(id => {
                gtag('config', id, {'page_path': path});
            })
        } else {
            console.log("gtag function isn't defined. Google Analytics doesn't triggered pageviews");
        }
    }

    protected _appendScripts(whereEl: HTMLElement): void {
        if (this._hasTrackingId()) {
            this._config.tracking_id.forEach(id => {
                const scripttgm = document.createElement('script');
                scripttgm.async = true;
                scripttgm.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
                whereEl.appendChild(scripttgm);

                const scriptga = document.createElement('script');
                scriptga.innerHTML = `window.dataLayer = window.dataLayer || [];
                                  function gtag(){dataLayer.push(arguments);}
                                  gtag('js', new Date());
                                  gtag('config', '${id}', {'send_page_view': false});`;
                whereEl.appendChild(scriptga);
            });
        }
    }

    protected _appendGTMScripts(whereEl: HTMLElement): void {
        if (this._config.tracking_id) {
            const scripttgm = document.createElement('script');
            scripttgm.async = true;
            whereEl.appendChild(scripttgm);

            const scriptgtm = document.createElement('script');
            scriptgtm.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${this._config.tracking_id}');`;
            whereEl.appendChild(scriptgtm);

            const noscript = document.createElement('noscript')
            const iframe = document.createElement('iframe')
            iframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${this._config.tracking_id}`)
            iframe.setAttribute("height", "0")
            iframe.setAttribute("width", "0")
            iframe.setAttribute("style", "display:none;visibility:hidden")
            noscript.appendChild(iframe)
            document.body.appendChild(noscript)
        }
    }
}
